import React, { useEffect, useState } from "react";
import { PostBackoffice } from "../../../utils/request";
import { CreateTagCommand, CreateTagResponse } from "../types";
import { AddModal } from "../../../components/molecules/AddModal";
import CustomButton from "../../../components/molecules/button";
import { ColorPicker } from "../../../components/molecules/colorPicker";
import { text_colors } from "../../../theme";
import { TextField } from "@mui/material";
import { v4 as uuidv4 } from 'uuid';

const defaultColor = "#f9f6ee"

export const CreateTag = ({ onTagSaved = () => { }, existingTags = [] }: { onTagSaved?: (tag: CreateTagCommand) => void, existingTags: CreateTagCommand[] }) => {

  const [tags, setTags] = useState<CreateTagCommand[]>([])
  const [existingColors, setExistingColors] = useState<string[]>([])
  const [newTag, setNewTag] = useState({ id: uuidv4(), text: '', colorCode: defaultColor });
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState("");
  const [savingState, setSavingState] = useState<"idle" | "saving" | "failed">("idle");

  useEffect(() => {
    if(existingTags.length !== 0) {
      setExistingColors(
        existingTags
          .map(t => t.colorCode)
          .filter((color): color is string => color != null)
      );
    }
  }, [existingTags])

  const createNewTag = async () => {
    const exists = existingTags.some(
      tag => tag.text.trim().toLowerCase() === newTag.text.trim().toLowerCase()
    );

    const colorExists = existingTags.some(
      tag => tag.colorCode === newTag.colorCode
    );

    if (exists) {
      setErrorMessage("A tag with this name already exists.");
      return;
    }

    if (colorExists) {
      setErrorMessage("A tag with this color already exists.");
      return;
    }

    const tagWithId = {
      ...newTag,
      id: uuidv4()
    };
    setSavingState("saving");
    try {
      const result = await PostBackoffice<CreateTagResponse>('cmd/tags/create', tagWithId);
      const createdTag = result.command;
      setTags(prev => [...prev, createdTag]);
      setNewTag({ id: '', text: '', colorCode: defaultColor });
      onTagSaved(createdTag)
      setModalOpen(false);
    } catch (error) {
      console.error('Could not create tag:', error);
      setErrorMessage("Failed to create tag.");
      setSavingState("failed");
    } finally {
      setSavingState("idle");
    }
  };


  return (
    <>
      <CustomButton noBg onClick={() => {
        setModalOpen(true)
      }}>
        {'+ Add Tag'}
      </CustomButton>
      <AddModal
        title="New tag"
        saving={savingState}
        savingFailedMessage="Failed"
        savingDisabled={!newTag.text || !!errorMessage}
        open={modalOpen}
        closeModal={() => {
          setModalOpen(false);
        }}
        onSave={createNewTag}
      >
        <div style={{ width: "430px" }}>
          <TextField
            autoFocus
            margin="normal"
            type="text"
            label="Tag name"
            id="tag_input_field"
            fullWidth
            defaultValue={newTag}
            value={newTag.text}
            onChange={(e) => {
              setNewTag({ ...newTag, text: e.target.value })
              setErrorMessage("");
            }}

          />
          {errorMessage && (
            <div style={{ color: text_colors.red, marginTop: 8 }}>{errorMessage}</div>
          )}

          <div style={{ marginTop: 20 }}>
            <ColorPicker
              color={newTag.colorCode}
              setColor={(newColor) => setNewTag({ ...newTag, colorCode: newColor ?? defaultColor })}
              excludeColors={existingColors}
            />
          </div>
        </div>
      </AddModal>
    </>
  )
}
